import { Modal, Timeline } from "antd";

const AuditLogsModalView = ({ open, auditLogs = [], ticker = '', onClose }) => {
    // 格式化字段名称，使其更易读
    const formatFieldName = (fieldName) => {
        const fieldNameMap = {
            'stop_loss_price': 'Stop Loss Price',
            'time_horizon_days': 'Time Horizon Days',
            'summary': 'Summary',
            'recommended_action': 'Recommended Action',
            'status': 'Status',
            'target_price': 'Target Price',
            'locked_performance': 'Locked Performance',
            'exit_detail': 'Exit Detail',
        };
        return fieldNameMap[fieldName] || fieldName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    };

    // 渲染单个字段的变化
    const renderFieldChange = (key, value, isNested = false) => {
        const oldVal = value?.old !== undefined ? String(value.old) : '';
        const newVal = value?.new !== undefined ? String(value.new) : '';

        return (
            <div key={key} style={{marginBottom: 4, paddingLeft: isNested ? 12 : 0}}>
                <span style={{color: '#999', fontSize: isNested ? 11 : 12}}>
                    {isNested ? '• ' : ''}{formatFieldName(key)}:
                </span>
                <span style={{marginLeft: 8, color: '#ff4d4f', textDecoration: 'line-through', fontSize: isNested ? 11 : 12}}>
                    {oldVal || '(empty)'}
                </span>
                <span style={{margin: '0 6px', color: '#999'}}>→</span>
                <span style={{color: '#52c41a', fontSize: isNested ? 11 : 12}}>
                    {newVal || '(empty)'}
                </span>
            </div>
        );
    };

    return (
        <Modal
            title={`${ticker} Idea Log`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <div style={{maxHeight: '50vh', overflowY: 'auto'}}>
                <Timeline
                    style={{paddingLeft: 12, paddingTop: 24, paddingBottom: 24}}
                    items={auditLogs.map((log, index) => {
                        let changes = {};
                        try {
                            changes = JSON.parse(log.changes || '{}');
                        } catch (error) {
                            console.error('Failed to parse changes:', error);
                        }

                        // 分离 ai_report_txt 和其他字段
                        const aiReportChanges = changes.ai_report_txt || {};
                        const otherChanges = Object.entries(changes).filter(([key]) => key !== 'ai_report_txt');
                        const hasOtherChanges = otherChanges.length > 0;
                        const hasAiReportChanges = Object.keys(aiReportChanges).length > 0;

                        return {
                            key: index,
                            dot: <div style={{width: 12, height: 12, backgroundColor: '#1890ff', borderRadius: '50%'}} />,
                            children: (
                                <div>
                                    <div style={{marginBottom: 8}}>
                                        <strong>{log.action}</strong>
                                        <span style={{marginLeft: 12, color: '#666', fontSize: 12}}>
                                            {log.operator}
                                        </span>
                                        <span style={{marginLeft: 12, color: '#999', fontSize: 12}}>
                                            {log.createdAt}
                                        </span>
                                    </div>
                                    {log.reason && (
                                        <div style={{marginBottom: 8, color: '#666', fontSize: 12}}>
                                            <strong>Reason:</strong> {log.reason}
                                        </div>
                                    )}
                                    {hasOtherChanges && (
                                        <div style={{marginBottom: 8}}>
                                            <strong style={{fontSize: 12}}>Changes:</strong>
                                            <div style={{marginTop: 4, paddingLeft: 12, fontSize: 12, color: '#666'}}>
                                                {otherChanges.map(([key, value]) => renderFieldChange(key, value, false))}
                                            </div>
                                        </div>
                                    )}
                                    {hasAiReportChanges && (
                                        <div style={{marginBottom: 8}}>
                                            <strong style={{fontSize: 12}}>AI Report Changes:</strong>
                                            <div style={{marginTop: 4, paddingLeft: 12, fontSize: 12, color: '#666'}}>
                                                {Object.entries(aiReportChanges).map(([key, value]) => renderFieldChange(key, value, true))}
                                            </div>
                                        </div>
                                    )}
                                    {(log.versionTag || log.versionTitle || log.versionBody) && (
                                        <div style={{
                                            marginTop: 8,
                                            padding: 12,
                                            border: '1px solid #d9d9d9',
                                            borderRadius: 6,
                                            backgroundColor: log.action?.startsWith('approve') ? '#f6ffed' : '#fafafa'
                                        }}>
                                            <div style={{marginBottom: 6, fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Tag:</span>
                                                <span style={{marginLeft: 8, color: '#1890ff', fontWeight: 'bold'}}>{log.versionTag || '-'}</span>
                                            </div>
                                            <div style={{marginBottom: 6, fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Title:</span>
                                                <span style={{marginLeft: 8, color: '#333'}}>{log.versionTitle || '-'}</span>
                                            </div>
                                            <div style={{fontSize: 12}}>
                                                <span style={{color: '#999', fontWeight: 'bold'}}>Version Body:</span>
                                                <span style={{marginLeft: 8, color: '#666'}}>{log.versionBody || '-'}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        };
                    })}
                />
            </div>
        </Modal>
    );
};

export default AuditLogsModalView;

